import { AssessmentItem } from '@/models/Assessment';
import Exam from '@/models/Exam';
import ExamSchedule from '@/models/ExamSchedule';
import Klass from '@/models/Klass';
import { Model, Nullable } from '@/models/Model';

export enum ExamSchedulingStatusEnum {
  NOT_SCHEDULED = 'NOT_SCHEDULED',
  SCHEDULED = 'SCHEDULED',
}

export type ScheduledLessonExamKlass = Pick<Klass, 'id' | 'name'>;

export type ScheduledLessonExamAssessmentItem = Pick<
  AssessmentItem,
  'id' | 'name'
>;

export type ScheduledLessonExamExam = Pick<Exam, 'id' | 'name'> & {
  assessmentItem: Nullable<ScheduledLessonExamAssessmentItem>;
};

export type ScheduledLessonExamSchedule = Pick<
  ExamSchedule,
  'id' | 'opensAt' | 'closesAt'
>;

export default interface ScheduledLessonExam extends Model {
  datetime: string;
  klass: ScheduledLessonExamKlass;
  exam: ScheduledLessonExamExam;
  examSchedule: Nullable<ScheduledLessonExamSchedule>;
}
